import { entitiesRegistryEntries } from './component-registry.entities'
import { featuresRegistryEntries } from './component-registry.features'
import { sharedRegistryEntries } from './component-registry.shared'
import type { CatalogComponentEntry } from './component-registry.types'
import { widgetsRegistryEntries } from './component-registry.widgets'

export type { CatalogComponentEntry, CatalogComponentLayer } from './component-registry.types'

export const componentRegistry: CatalogComponentEntry[] = [
  ...sharedRegistryEntries,
  ...entitiesRegistryEntries,
  ...featuresRegistryEntries,
  ...widgetsRegistryEntries,
]
